var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../apiClient.js';
export const useRejectApplication = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (_a) => __awaiter(void 0, [_a], void 0, function* ({ ref, reason }) {
            const response = yield client.patch(`/agreements/${ref}/reject`, { reason });
            return response.data;
        }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['applications'] });
        },
    });
};
